import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { Button } from '@mantine/core';
import WhiteBox from '../WhiteBox/WhiteBox';
import './LeaveWorkspaceTab.scss';
import LeaveWorkspaceTabPresenter from '../../presenters/LeaveWorkspaceTabPresenter/LeaveWorkspaceTabPresenter';

const LeaveWorkspaceTab = ( { presenter } ) => (
	<div className="LeaveWorkspaceTab">
		<WhiteBox>
			<div className="title">
				<h4>Leave Workspace</h4>
			</div>
			<p>
				Upon leaving this workspace, you will automatically transfer ownership{' '}
				of all projects you own to the workspace owner and{' '}
				<strong className="body-focus">you will be removed from all projects in this workspace.</strong>
			</p>
			<Button
				mt="36px"
				color="red"
				size="sm"
				onClick={presenter.onLeaveWorkspaceClick}
			>
				Leave Workspace
			</Button>
		</WhiteBox>
	</div>
);

LeaveWorkspaceTab.propTypes = {
	presenter: PropTypes.instanceOf( LeaveWorkspaceTabPresenter ).isRequired
};

export default observer( LeaveWorkspaceTab );
